<template>
  <div>
    <highcharts
      ref="IncChart"
      :options="incomeChartOptions"
    ></highcharts>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import TooltipFormatter from "@/guiide/ts/tooltipFormatter";
import ChartSeries from "@/guiide/ts/chartSeries";

export default defineComponent({
  name: "IncomeChart",
  components: {
    highcharts: Chart
  },
  setup() {
    const IncChart = ref(null);

    return {
      IncChart
    };
  },
  props: {
    graphData: { type: Object as () => any, required: true, default: () => ({}) }
  },
  beforeUpdate() {
    this.IncChart.chart.reflow();
  },
  computed: {
    getIncomeChartData() {
      return this.$store.state.incomeChartData;
    },
    incomeChartOptions() {
      return {
        chart: {
          backgroundColor: "white",
          borderColor: "",
          borderWidth: 1,
          borderRadius: 3,
          zoomType: "x",
          panning: true,
          panKey: "shift",
          type: "column",
          height: 380
        },
        title: {
          text: "Annual payments expected",
          style: {
            color: "#5c5b5b",
            fontWeight: "600",
            fontSize: "13px"
          }
        },
        xAxis: {
          title: {
            text: "Age",
            style: {
              color: "#5c5b5b",
              fontSize: "12px"
            }
          },
          allowDecimals: false,
          tickInterval: 1,
          tickLength: 0
        },
        yAxis: {
          min: 0,
          max: 60000,
          title: {
            text: "",
            rotation: 0,
            style: {
              color: "Black",
              fontWeight: "500",
              fontSize: "14px"
            }
          },
          labels: {
            formatter: function() {
              return (
                "£" +
                Highcharts.numberFormat(this.value / 1000, 0, ".", ",") +
                "k"
              );
            }
          },
          stackLabels: {
            enabled: false,
            style: {
              fontWeight: "bold",
              color: "gray"
            }
          }
        },
        legend: {
          enabled: true,
          verticalAlign: "bottom",
          floating: false,
          backgroundColor: "white",
          borderColor: "",
          borderWidth: 0,
          borderRadius: 0,
          shadow: false,
          itemMarginBottom: 6,
          itemStyle: {
            color: "Grey",
            fontWeight: "lighter",
            fontSize: "12px"
          }
        },
        // tooltip: {
        //   borderColor: "DimGrey",
        //   backgroundColor: "#EBF4FA",
        //   borderWidth: 0,
        //   borderRadius: 10,
        //   shadow: false,
        //   animation: true,
        //   formatter: function() {
        //     const allSeries = this.series.chart.series;
        //     const allChartSeries = new Array<ChartSeries>();
        //     allSeries.forEach(s => {
        //       const yData = s.data.map(d => d.y);
        //       const chartSeries = new ChartSeries(s.name, yData);
        //       allChartSeries.push(chartSeries);
        //     });
        //     return TooltipFormatter.createNew(this.x, allChartSeries);
        //   },
        //   positioner: function(labelWidth, labelHeight, point) {
        //     return {
        //       x: Math.max(point.plotX - labelWidth + 45, 10),
        //       y: 0
        //     };
        //   }
        // },
        plotOptions: {
          line: {
            pointStart: 1
          },
          column: {
            pointPadding: -0.1,
            borderWidth: 1,
            shadow: false,
            borderRadius: 0,
            stacking: "normal",
            dataLabels: {
              enabled: false,
              color: "black"
            },
            pointStart: 1,
            cursor: "pointer",
            point: {
              events: {
                click: ({ point }) => {
                  this.configureForDetailChart(point.category);
                }
              }
            }
          }
        },
        series: this.graphData
      };
    }
  }
});
</script>

<style>
.highcharts-container {
  width: 100% !important;
}
</style>
